const TOGGLE_MENU = "TOGGLE_MENU";
const CLOSE_MENU = "CLOSE_MENU";

export default {
  TOGGLE_MENU,
  CLOSE_MENU,
};
